import { track_ga } from '@/pages/firebase'

// 站内消息tip曝光
export const messageToastShow = (params) => {
  track_ga('message_toast_show', params)
}
// 站内消息tip点击
export const messageToastClick = (params) => {
  track_ga('message_toast_click', params)
}
